/**
 * Which Messages spaces the signed-in person sees (Ben, 13 Oct 2026):
 *
 *   Team      everyone
 *   Clients   owners, self-employed stylists (their own clients), and staff
 *             whose role has Client messages or all clients (clients_all)
 *   Support   owners and self-employed stylists; employed staff ask the owner
 *
 * The UI only hides. The server must refuse client and support chats to
 * anyone these rules leave out (backend brief, section 22).
 */
import { getAccess, isSelfEmployedMe, useAccess } from '../../permissions/access';

export const ALL_SPACES = ['clients', 'team', 'support'];

/** Pure, for tests: access = { owner, caps }, selfEmployed = true/false. */
export function spacesFor(access, selfEmployed) {
    const a = access || {};
    const caps = a.caps || [];
    const out = [];
    if (a.owner || selfEmployed || caps.indexOf('client_messages') !== -1 || caps.indexOf('clients_all') !== -1) out.push('clients');
    out.push('team');
    if (a.owner || selfEmployed) out.push('support');
    return out;
}

export function allowedSpaces() {
    return spacesFor(getAccess(), isSelfEmployedMe());
}

export function canSeeSpace(space) {
    return allowedSpaces().indexOf(space) !== -1;
}

/** Live: updates when the person's access loads or changes. */
export function useAllowedSpaces() {
    const { access } = useAccess();
    return spacesFor(access, isSelfEmployedMe());
}
